import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResource } from '../../core/abstractions/base.resource';
import { ActionResultModel } from '../../models/core/action-result.model';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { NotificationSettingsModel } from '../../models/notification-settings.model';

@Injectable({
    providedIn: 'root'
})
export class NotificationSettingsResource extends BaseResource {
    constructor() {
        super(new ResourceConfig({ baseController: 'notification-settings' }));
    }

    get(): Observable<ApiResponseModel<NotificationSettingsModel>> {
        return this._requestService.makeGet<ApiResponseModel<NotificationSettingsModel>>(this.getUrl(''));
    }

    update(request: NotificationSettingsModel): Observable<ApiResponseModel<ActionResultModel>> {
        return this._requestService.makePost<ApiResponseModel<ActionResultModel>>(this.getUrl(''), request);
    }
}
